import { faFolderPlus, faPenCircle } from "@fortawesome/pro-solid-svg-icons"
import { translate } from "app/language/service"
import { IRootState } from "app/model"
import React from "react"
import { connect } from "react-redux"
import { Popup } from "ui/components/Popup"
import { isPhoneScreen } from "ui/tools/responsive"
import { IUserImpersonator, IUserImpersonatorHydrated } from "user/model"
import { ImpersonatorForm } from "./ImpersonatorForm"

interface IImpersonatorFormPopupProps {
  existingImpersonators: IUserImpersonator[]
  impersonator: IUserImpersonatorHydrated | null
  onSave: (impersonator: IUserImpersonatorHydrated) => any
  onClose: () => any
}

interface IImpersonatorFormPopupConnectProps {
  isPhone: boolean
}

const ImpersonatorFormPopupFn = React.memo(
  ({
    impersonator,
    existingImpersonators,
    onClose,
    onSave,
    isPhone
  }: IImpersonatorFormPopupProps & IImpersonatorFormPopupConnectProps) => {
    const isCreation = React.useMemo(() => !impersonator, [impersonator])
    return (
      <Popup
        icon={isCreation ? faFolderPlus : faPenCircle}
        id="user-form-popup"
        title={translate(isCreation ? "user.impersonator.add.title" : "user.impersonator.update.title")}
        onClose={() => onClose()}
        minWidth={isPhone ? "calc(100% - 2rem)" : "25rem"}
        maxWidth={isPhone ? "calc(100% - 2rem)" : "30rem"}
        sx={{
          "& .MuiDialogContent-root": {
            maxWidth: "100%",
            maxHeight: "100%"
          },
          "& h2.MuiDialogTitle-root": { minWidth: 0 },
          "& h2.MuiDialogTitle-root p": { marginRight: "1rem" }
        }}>
        <ImpersonatorForm
          impersonator={impersonator || undefined}
          existingImpersonators={existingImpersonators}
          onCancel={() => onClose()}
          onSave={onSave}
        />
      </Popup>
    )
  }
)

export const ImpersonatorFormPopup = connect(
  (state: IRootState): IImpersonatorFormPopupConnectProps => ({
    isPhone: isPhoneScreen(state)
  })
)(ImpersonatorFormPopupFn)
